import React from 'react';
import { withRouter } from 'react-router-dom';
import '../components/componentsCSS/FormRegister.css';
import { Form, FormGroup } from 'reactstrap';

import InputForm from './InputForm';
import BlueButton from './BlueButton';

import back from '../img/Back.png';




const FormRegister = (props) => {
    return (
        <div>
            <div className='bck'>
                <img src={back} alt='back' onClick={() => props.history.push('/login')} />
            </div>
            <div className='d-flex justify-content-center mt-5'>
                <img src='https://github.com/BrendaCarranco/laaps/blob/master/img/logoNombre.png?raw=true' alt='logo' />
            </div>
            <Form className="login-form">
                <FormGroup>
                    <InputForm placeholder={'Nombre y apellido'} type='text' className='mt-3' />
                </FormGroup>
                <FormGroup>
                    <InputForm placeholder={'Correo electrónico'} type='email' />
                </FormGroup>
                <FormGroup>
                    <InputForm placeholder={'Contraseña'} type='password' />
                    <p>                    Usa 8 o más caracteres y combina letras y números
</p>
                </FormGroup>
            </Form>
            <div className='container'>
                <BlueButton label={'¡Empecemos!'} />

            </div>
        </div>
    );
};

export default withRouter(FormRegister);